import { useStorage } from '../hooks/useStorage';

const PROTOCOL = process.env.REACT_APP_API_PROTOCOL || window.location.protocol;

const HOSTNAME = process.env.REACT_APP_API_HOSTNAME || window.location.hostname;

const PORT = process.env.REACT_APP_API_PORT || window.location.port;

const SUBDIR = process.env.REACT_APP_API_SUBDIR;

const API_URL = SUBDIR ? `${PROTOCOL}//${HOSTNAME}/${SUBDIR}` : `${PROTOCOL}//${HOSTNAME}:${PORT}`;

const storage = useStorage();

export async function fetchWithTimeout(
    route: string,
    init: RequestInit = {},
    timeout: number = 30000,
    token: string = storage.getAuth().token,
): Promise<Response> {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(`${API_URL}/${route}`, {
        ...init,
        headers: { ...init.headers, Authorization: `Bearer ${token}` },
        signal: controller.signal,
    }).catch();
    clearTimeout(id);
    return response;
}
